export default __webpack_public_path__ + "static/media/site.63c6f040.svg";